export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/arrow-down.dc0c6343.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};